import { observer } from 'mobx-react-lite'
import React from 'react'
import BudgetDataTable from './BudgetDataTable'

/**
 * Hidden influencers: same table layout and column set as the main budget table, with row data filled in.
 * Cells are read-only (no `onInputCellChange`). Influencer visibility switch is always shown so rows can be restored.
 */
export default observer(function BudgetHiddenInfluencersList({
  tableConfig,
  forcedHiddenColumns,
  editingColumns,
  draftColumns,
  visibleColumns,
  onToggleColumn,
  rows,
  tableKind,
  campaignScenario,
}) {
  return (
    <BudgetDataTable
      config={tableConfig}
      forcedHiddenColumns={forcedHiddenColumns}
      editingColumns={editingColumns}
      draftColumns={draftColumns}
      visibleColumns={visibleColumns}
      onToggleColumn={onToggleColumn}
      rows={rows}
      tableKind={tableKind}
      campaignScenario={campaignScenario}
      showInfluencerVisibilityToggle
      className="mt-2"
      keyPrefix="hidden-"
      forceRowsReadOnly
      hideWhenEmpty
    />
  )
})
